
import React, { useEffect } from 'react';
import '../Assets/Css/diversity.css';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Helmet } from 'react-helmet';
import aboutdiversity from '../Assets/Image/diversityimg1.avif'
import diversity2 from '../Assets/Image/diversityimg2.avif'

// testimonials
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import { FaStar } from 'react-icons/fa';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { FaLinkedin, FaTwitter } from 'react-icons/fa';

export default function Diversity() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const testimonials = [
    "Trident’s solutions transformed our business operations — efficient, scalable, and tailored perfectly to our needs.",
    "Partnering with Trident empowered us to innovate faster and streamline workflows across all departments.",
    "The team at Trident combines deep expertise with a supportive approach, delivering results that truly matter.",
    "Since implementing Trident’s software, we’ve seen remarkable improvements in productivity and decision-making.",
    "Trident’s commitment to innovation and quality has made them a trusted partner in our digital transformation journey."
  ];

  return (
    <>
<Helmet>
        <title>Driving Success Through Diversity | Trident Software Services</title>
        <meta name="description" content="Empowering innovation and growth with a diverse, inclusive workforce. See how Trident drives measurable impact through diversity hiring and inclusive strategy." />
        <meta property="og:title" content="Driving Success Through Diversity" />
        <meta property="og:description" content="Empowering innovation, inclusion, and growth through a diverse and dynamic workforce." />
      </Helmet>

      {/* Banner Section */}
      <div className="banner2-section d-flex align-items-center justify-content-center">
        <div className="banner2-overlay text-center" data-aos="zoom-in">
          <h2 className="banner1-title">Driving Success Through Diversity</h2>
          <p className="banner1-subtitle" data-aos="zoom-in" data-aos-delay="200">
            Empowering innovation, inclusion, and growth through a diverse and dynamic workforce.
          </p>

        </div>
      </div>

      {/* About Us Section */}
      <section className="py-5" id="about">
        <Container>
          <Row className="align-items-center">
            <Col md={7} data-aos="zoom-in">
              <Row className="text-center section-heading" data-aos="zoom-in" data-aos-delay="200">
                <Col>
                  <h3 className="fw-bold section-title">
                    Why Diversity Matters
                    <span className="title-decoration"> </span>
                  </h3>
                  <p className="text-muted mx-auto" style={{ maxWidth: 700 }}>
                    Diverse teams drive better outcomes, spark innovation, and build stronger companies.
                  </p>
                </Col>
              </Row>

              <p>
                At  <strong className='about-home-bold'>Trident Software Services</strong>, we understand that diversity is not just a value — it's a business driver.
                Diverse teams bring varied perspectives, foster innovation, and lead to smarter, more inclusive decisions.
                In a world where technology evolves rapidly, organizations that embrace diversity are better equipped
                to adapt, grow, and outperform the competition.
              </p>
            </Col>

            <Col md={5} data-aos="zoom-in" className="d-flex justify-content-center align-items-center ">
              <img src={aboutdiversity} alt="About Vinora" className="aboutimg  " />
            </Col>
          </Row>
        </Container>
      </section>

      <section className="py-5 mb-3  vinora-background">
        <Container>
          {/* <Row className="text-center mb-4" data-aos="zoom-in">
            <Col>
             

            </Col>
          </Row> */}

          <Row className="align-items-center justify-content-center">
            <Col md={6} >
              <img
                src={diversity2}
                alt="diversity2"
                className="nskchoco  mb-2"


              />
            </Col>
            <Col md={6} data-aos="zoom-in" >
             <h3 className="fw-bold text-white section-title mb-4">
                How We Deliver Measurable Impact
                {/* <span className="title-decoration"> </span> */}
              </h3>
              <ul>
                <li>Ongoing diversity audits and performance tracking</li>
                <li>64% of hires placed in roles that shape business strategy</li>
                <li>Access to underrepresented but high-potential candidates</li>
                <li>Tailored recruitment strategy with inclusion at its core</li>
              </ul>
            </Col>
          </Row>


          <Row className="text-center mt-4">
            <Col>
              <Button variant="light" href='/ourproducts' style={{ border: 'none' }} className='viewbutton' size="lg" data-aos="zoom-in">
                Explore Our Products
              </Button>
            </Col>
          </Row>
        </Container>
      </section>





      <section className="py-5" id="sustainability">
        <Container>
          <Row className="text-center mb-4" data-aos="fade-up">
            <Col>
              <h3 className="fw-bold section-title">
                Business Advantages of a Diverse Workforce
                <span className="title-decoration"> </span>
              </h3>
              <p className="text-muted mx-auto" style={{ maxWidth: 700 }}>
                A diverse workforce fosters innovation, enhances decision-making, and drives stronger business outcomes by bringing varied perspectives and experiences together.
              </p>
            </Col>
          </Row>


          {/* Image row */}




          <Row className="justify-content-center text-center">
            <Col md={12} data-aos="fade-up" data-aos-delay="50">
              <Row className="justify-content-center gx-4 gy-4">
                {[
                  { title: 'Reduced Risk', desc: 'Strong diversity frameworks help prevent internal bias and reduce legal vulnerability.' },
                  { title: 'Talent Magnet', desc: 'Purpose-driven workplaces attract and retain top talent from all backgrounds.' },
                  { title: 'Broader Market Access', desc: 'A more diverse team fosters deeper connections with global customers and partners.' },
                  { title: 'Creative Edge', desc: 'Varied experiences fuel fresh thinking and drive product innovation.' },
                  { title: 'Performance Uplift', desc: 'Data-backed insights show diverse teams often see a 19% or greater revenue boost.' },
                ].map((item, idx) => (
                  <Col xs={6} sm={4} md={2} className="d-flex justify-content-center" key={idx}>
                    <div className="diversity-circle">
                      <div className="circle-title">{item.title}</div>
                      <div className="circle-desc">{item.desc}</div>
                    </div>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="py-5 faq-section position-relative" id="faq">
        <Container>
          <Row className="text-center mt-4 mb-3" data-aos="zoom-in">
            <Col>
              <h3 className="fw-bold text-white section-title">
                Did You Know?
                <span className="title-decoration"> </span>
              </h3>
              <p className="text-light">
                Diversity and inclusion aren't just buzzwords — they have a real impact on performance, innovation, and workplace culture.
              </p>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col md={8}>
              <div className="faq-card" data-aos="fade-up" data-aos-delay="100">
                <p>
                  🌍 <strong>Inclusive companies are 1.7x more likely</strong> to be innovation leaders in their industry. When different perspectives come together, creative thinking thrives.
                </p>
              </div>
              <div className="faq-card" data-aos="fade-up" data-aos-delay="200">
                <p>
                  ✅ <strong>67% of job seekers</strong> say that a diverse workforce is a key factor when evaluating job offers. Inclusion drives talent attraction and retention.
                </p>
              </div>
              <div className="faq-card" data-aos="fade-up" data-aos-delay="300">
                <p>
                  📈 Companies with diverse leadership teams experience up to <strong>19% higher revenue</strong> than their peers. Diversity isn't just good ethics — it's smart business.
                </p>
              </div>
              <div className="faq-card" data-aos="fade-up" data-aos-delay="400">
                <p>
                  💼 <strong>Diverse teams make better decisions</strong> 87% of the time. Different backgrounds mean broader analysis and stronger outcomes.
                </p>
              </div>
              <div className="faq-card" data-aos="fade-up" data-aos-delay="500">
                <p>
                  🌟 <strong>Companies that embrace diversity</strong> see improved employee satisfaction, better collaboration, and reduced turnover.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="testimonial-carousel-section my-5">
        <div className="container py-3 ">
          <Row className="align-items-center justify-content-center flex-md-row m-0">
            <h3 className="fw-bold text-center section-title">
              Empowering Innovation Through Experience
              <span className="title-decoration mb-2"></span>
            </h3>
            <p className="text-muted mx-auto" style={{ maxWidth: 700 }}>
              Hear what our clients say about transforming their business with Trident Software Services.
            </p>
            <Col xs={12} md={8} className="text-center order-1 order-md-2" data-aos="zoom-in" data-aos-delay="200">

              <Swiper
                modules={[Autoplay, Pagination, Navigation]}
                spaceBetween={30}
                loop={true}
                autoplay={{
                  delay: 5000,
                  disableOnInteraction: false,
                }}
                pagination={{ clickable: true }}
                navigation={true}
                className="testimonial-swiper"
              >
                {testimonials.map((text, idx) => (
                  <SwiperSlide key={idx}>
                    <div className="stars mb-1">
                      {[...Array(5)].map((_, i) => (
                        <FaStar key={i} color="#d23f57" />
                      ))}
                    </div>
                    <p className="testimonial-quote">
                      <span className="quote-mark">“</span>
                      {text}
                      <span className="quote-mark">”</span>
                    </p>
                    <p className="author-name">Anonymous</p>
                  </SwiperSlide>
                ))}
              </Swiper>
            </Col>
          </Row>
        </div>
      </section>


    </>
  );
}
